import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductsState } from "./products.state";
import { getProducts } from "./products.thunk";
import { ProductsData, ProductsResponse } from "./products.types";

const initialState: ProductsState = {
  data: null,
  status: "idle",
  error: null,
  currentFilters: null,
  ssrHydrated: false,
};

export const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    resetProducts: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.currentFilters = null;
      state.ssrHydrated = false;
    },
    loadInitialProducts: (state, action: PayloadAction<ProductsData>) => {
      if (state.status !== "idle") return;
      state.data = action.payload;
      state.status = "success";
      state.ssrHydrated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state, action) => {
        // Create filter key from params (excluding page)
        const { page, ...filters } = action.meta.arg;
        const filterKey = JSON.stringify(filters);
        const isNewFilter = state.currentFilters !== filterKey;
        const isFirstPage = (page || 1) === 1;

        if (isNewFilter) {
          state.data = null;
          state.currentFilters = filterKey;
        } else if (isFirstPage) {
          state.data = null;
        }

        state.status = "loading";
        state.error = null;
        state.ssrHydrated = false; // ilk client fetch SSR bayrağını temizler
      })
      .addCase(
        getProducts.fulfilled,
        (state, action: PayloadAction<ProductsResponse>) => {
          state.status = "success";
          const isFirstPage = action.payload.data.pagination.current_page === 1;
          
          if (isFirstPage) {
            state.data = action.payload.data;
          } else {
            // Append to existing items
            if (state.data) {
              state.data = {
                ...state.data,
                items: [
                  ...state.data.items,
                  ...action.payload.data.items,
                ],
                pagination: action.payload.data.pagination,
              };
            }
          }
        },
      )
      .addCase(
        getProducts.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error =
            action.payload ?? "Ürünler yüklenirken bir hata oluştu.";
        },
      );
  },
});

export const { resetProducts, loadInitialProducts } = productsSlice.actions;
export default productsSlice.reducer;